const PASO_MAXIMO = 7

const StepToRoute = {
  'P1' : '/ddjj/terminos',
  'P2' : '/ddjj/datos-contribuyente',
  'P3' : '/ddjj/datos-comercial',
  'P4' : '/ddjj/determinacion-tasa',
  'P5' : '/ddjj/deducciones-exclusiones',
  'P6' : '/ddjj/pagos',
  'P7' : '/ddjj/emision-ddjj',
  'F' : '/ddjj/confirmacion-cuit'
}

const MapStepToRoute = (paso) => {
  return StepToRoute[paso] ?? StepToRoute['P1']
}

const RouteToStep = {
  '/ddjj/terminos': 1,
  '/ddjj/datos-contribuyente': 2,
  '/ddjj/datos-comercial': 3,
  '/ddjj/determinacion-tasa': 4,
  '/ddjj/deducciones-exclusiones': 5,
  '/ddjj/pagos': 6,
  '/ddjj/emision-ddjj': 7
}

const MapRouteToStep = (route) => {
  return RouteToStep[route] ?? 1
}

export {
  MapStepToRoute,
  MapRouteToStep,
  PASO_MAXIMO
}
